import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/route'

import component from 'components/Routes/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => ({
  route: state.route
})

const form = reduxForm({
  form: 'edit-route',
  fields: ['id', 'name', 'desc', 'region'], // NOTE: id can't be updated, just used to send to API
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
}, state => ({
  initialValues: state.route
}))(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Routes/containers/EditRouteContainer.js